{
  "unsubscribe_title": "Darse de baja de los correos electrónicos",
  "unsubscribe_message": "Lamentamos verte partir.",
  "unsubscribe": "Darse de baja",
  "cancel": "Cancelar",
  "passwordResetSuccess": "Tu contraseña ha sido cambiada exitosamente.",
  "passwordResetError": "Desafortunadamente, hubo un problema",
  "passwordResetExpired": "Este enlace no es válido o ha caducado. Solicita un nuevo correo para restablecer tu contraseña.",
  "passwordResetTitle": "Establecer una nueva contraseña",
  "new_password": "Nueva contraseña",
  "confirm_password": "Confirmar nueva contraseña",
  "save": "Guardar",
  "error": "Desafortunadamente, hubo un problema",
  "unsubscribeSuccess": "La acción fue exitosa",
  "emailChangeLoading": "Cambio de correo electrónico en proceso...",
  "emailChangeSuccess": "El correo electrónico fue cambiado exitosamente",
  "emailChangeError": "Desafortunadamente, hubo un problema al cambiar el correo electrónico",
  "home": {
    "tagline": "Más de 1 millón de dueños de perros entrenan con Hundeo",
    "subline": "Recomendada por adiestradores profesionales",
    "appStorePrefix": "Descarga en",
    "playStorePrefix": "Disponible en",
    "qrHint": "Abrir la app en tu móvil",
    "qrCaption": "Escanea el código con tu cámara",
    "socialProof": "5.000+ reseñas de 5 estrellas",
    "imprint": "Aviso legal",
    "privacy": "Privacidad",
    "language": "Idioma",
    "openWebsite": "Ir a la web",
    "openInApp": "Abrir en la app Hundeo",
    "openInAppHint": "Te llevamos a tu app",
    "openInAppButton": "Abrir",
    "promoRedirectTitle": "Abriendo tu oferta …",
    "promoRedirectButton": "Ir a tu oferta"
  }
}
